const Styles = {
  containerStyle: {
    backgroundColor: '#fff9c4',
    height: 60,
    top: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'absolute',
    zIndex: 201
  },
  buttonContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/containers/OfflineModeHeader/styles.js